import { frontendURL } from 'dashboard/helper/URLHelper.js';
import CrmPage from './CrmPage.vue';

const crmRoutes = {
  routes: [
    {
      path: frontendURL('accounts/:accountId/crm'),
      name: 'crm_index',
      meta: {
        permissions: ['administrator', 'agent'],
      },
      component: CrmPage,
    },
  ],
};

export default crmRoutes;
